/**
 * The `returnTo` a sign-in or onboarding flow goes back to: a path inside this app, or
 * nothing. Anything that could leave the origin is refused: «//host» and «/\host» (a
 * browser reads both as a protocol-relative URL), an absolute URL, a backslash anywhere,
 * a control character. The result is checked the way the browser will resolve it.
 */
export function safeReturnTo(raw: string | null | undefined, fallback = '/home'): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return fallback
  if (raw.includes('\\') || Array.from(raw).some((c) => c.charCodeAt(0) < 0x20 || c.charCodeAt(0) === 0x7f)) return fallback
  try {
    const base = window.location.origin
    return new URL(raw, base).origin === base ? raw : fallback
  } catch {
    return fallback
  }
}
